import { z } from 'zod';

export const GimaModel = z.object({
  access: z.string(),
  refresh: z.string(),
});
